import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageSubscriptionStore } from "./localStorageStore";
import { createSupabaseSubscriptionStore } from "./supabaseStore";
import type { SubscriptionStore } from "./types";

// Same selection pattern as other stores: pick the backend at import time.
// Playwright runs with VITE_E2E_BYPASS_AUTH=true, forcing the localStorage
// implementation so tests don't depend on a live Supabase.
const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const subscriptionStore: SubscriptionStore = useLocal
  ? createLocalStorageSubscriptionStore()
  : createSupabaseSubscriptionStore();

export type {
  NewSubscriptionInput,
  Subscription,
  SubscriptionCadence,
  SubscriptionStatus,
  SubscriptionStore,
} from "./types";
